import type { RatingStaticContent } from '@core-api/editor/types/response';
import type { Question } from '@mentimeter/legacy-series-types/question';
import { questionTextLayoutToSlideTextLayout } from '../converters/question/question-text-layout-to-slide-text-layout';
import { questionToSlideImageReference } from '../converters/question/question-to-slide-image-reference';
import { questionLayoutToSlideLayout } from '../converters/question/question-layout-to-slide-layout';
import { questionDimensionsToSlideRatingAxisLabels } from '../converters/question/question-dimensions-to-slide-rating-axis-labels';
import { questionSubTypeToSlideVisualization } from '../converters/question';

type InteractiveContentStyling =
  RatingStaticContent['interactiveContentStyling'];

export const getRatingStaticContent = (question: Question) => {
  const { textSizeOffset } = questionTextLayoutToSlideTextLayout(
    question.layout,
  );

  const [slideLayout] = questionLayoutToSlideLayout(question.layout);
  const axisLabels = questionDimensionsToSlideRatingAxisLabels(
    question.dimensions,
  );

  const content: RatingStaticContent = {
    layout: slideLayout,
    type: 'rating',
    label: question.title_meta,
    styledTitle: question.question_styled ?? {},
    image: {
      ...questionToSlideImageReference(question),
    },
    textSizeOffset,
    interactiveContentStyling: {
      visualization: (questionSubTypeToSlideVisualization(question.sub_type) ??
        'two-values') as InteractiveContentStyling['visualization'],
      xAxisLabels: axisLabels.xAxisLabels,
      yAxisLabels: axisLabels.yAxisLabels,
      gridImageKey: question.image?.id as string,
      gridImageRotation: question.grid.rotation ?? 0,
    },
  };

  return content;
};
